import { render } from "./adminOperation.vue?vue&type=template&id=b6c744c4&scoped=true"
import script from "./adminOperation.vue?vue&type=script&lang=js"
export * from "./adminOperation.vue?vue&type=script&lang=js"

import "./adminOperation.vue?vue&type=style&index=0&id=b6c744c4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6c744c4"]])

export default __exports__